import { Inventory2Outlined, UnarchiveOutlined } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Button } from "components/buttons/button";
import { useArchiveTempWorker } from "core/temp_workers/hooks";
import { useState } from "react";
import { toast } from "react-toastify";

type Props = {
  tempWorker: any;
};

export function ArchiveButton({ tempWorker }: Props) {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);

  const handleClickOpen = () => setOpenConfirmDialog(true);
  const handleClose = () => setOpenConfirmDialog(false);

  const { mutate, isLoading } = useArchiveTempWorker({
    onSuccess: (data: any) => toast.success("Le candidat a bien été archivé."),
    onError: (error: any) =>
      toast.error("Le Candidat n'a pas pu être archivé."),
  });

  if (tempWorker?.account?.synced && tempWorker?.account?.archived) {
    return (
      <>
        <Button
          variant="outlined"
          size="small"
          color="info"
          onClick={handleClickOpen}
          disabled={isLoading}
        >
          <UnarchiveOutlined /> Restaurer
        </Button>
        <Dialog open={openConfirmDialog} onClose={handleClose}>
          <DialogTitle>Restaurer?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Êtes-vous sûr(e) de vouloir restaurer ce candidat?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Annuler</Button>
            <Button
              onClick={() => {
                mutate({ id: tempWorker.id, archive: false });
                handleClose();
              }}
              autoFocus
            >
              Restaurer
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  if (tempWorker?.account?.synced && !tempWorker?.account?.archived) {
    return (
      <>
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={handleClickOpen}
          disabled={isLoading}
        >
          <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <Inventory2Outlined /> Archiver
          </Box>
        </Button>
        <Dialog open={openConfirmDialog} onClose={handleClose}>
          <DialogTitle>Archiver?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Êtes-vous sûr(e) de vouloir archiver ce candidat?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Annuler</Button>
            <Button
              onClick={() => {
                mutate({ id: tempWorker.id });
                handleClose();
              }}
              autoFocus
            >
              Archiver
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  return null;
}
